import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { ConfirmationProps } from './types';

const ConfirmationModal = (
  { show, onHide, modalConfig, modalContent, confirmAction } : ConfirmationProps
) => {
  const handleConfirmClick = () => {
    confirmAction && confirmAction();
    onHide();
  };

  let modalClassName = 'modal-confirmation';
  let titleClassName = '';
  let bodyClassName = '';
  let cancelClassName = 'cancel-button';
  let confirmClassName = '';
  let actionsClassName = '';

  if (modalConfig) {
    if (modalConfig.modalClassName) {
      modalClassName = modalConfig.modalClassName;
    }
    if (modalConfig.titleClassName) {
      titleClassName = modalConfig.titleClassName;
    }
    if (modalConfig.bodyClassName) {
      bodyClassName = modalConfig.bodyClassName;
    }
    if (modalConfig.cancelClassName) {
      cancelClassName = modalConfig.cancelClassName;
    }
    if (modalConfig.confirmClassName) {
      confirmClassName = modalConfig.confirmClassName;
    }
    if (modalConfig.actionsClassName) {
      actionsClassName = modalConfig.actionsClassName;
    }
  }

  let headerContent = 'CONFIRMATON MODAL';
  let bodyContent: React.ReactNode = 'THIS IS THE BODY OF OUR CONFIRMATION MODAL';
  let cancelContent = 'Cancel';
  let confirmContent = 'Confirm';

  if (modalContent) {
    if (modalContent.headerContent) {
      headerContent = modalContent.headerContent;
    }
    if (modalContent.bodyContent) {
      bodyContent = modalContent.bodyContent;
    }
    if (modalContent.cancelContent) {
      cancelContent = modalContent.cancelContent;
    }
    if (modalContent.confirmContent) {
      confirmContent = modalContent.confirmContent;
    }
  }

  return (
    <Modal className={modalClassName}
           show={show > 0}
           onHide={onHide}
           size="lg"
           aria-labelledby="contained-modal-title-vcenter"
           centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className={titleClassName}>{headerContent}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><i className="mdi mdi-alert"/></p>
        <div className={bodyClassName}>{bodyContent}</div>
        <div className="confim-ll"/>
        <div className={actionsClassName}>
          <button className={cancelClassName}
                  onClick={() => onHide()}>{cancelContent}</button>
          <button className={confirmClassName}
                  onClick={() => handleConfirmClick()}>{confirmContent}</button>
        </div>
      </Modal.Body>
    </Modal>);
};

export default ConfirmationModal;